export default "/images/decline.svg?11653fdd886147103f4c25bb903f2d13";